import script from "./SearchInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchInput.vue?vue&type=script&lang=ts&setup=true"

import "./SearchInput.vue?vue&type=style&index=0&id=5fb56da0&lang=scss"

const __exports__ = script;

export default __exports__